var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUndo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4578_253969)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.98964 12.7648L0.864639 8.63978C0.671126 8.44632 0.517619 8.21663 0.412887 7.96383C0.308155 7.71103 0.254251 7.44008 0.254251 7.16645C0.254251 6.89281 0.308155 6.62186 0.412887 6.36906C0.517619 6.11627 0.671126 5.88658 0.864639 5.69311L4.98964 1.56812L6.17131 2.74978L2.58797 6.33312H17.6713C18.3396 6.31766 18.9867 6.56773 19.4709 7.02852C19.9551 7.48931 20.237 8.12325 20.2546 8.79145V18.0414C20.237 18.7096 19.9551 19.3436 19.4709 19.8044C18.9867 20.2652 18.3396 20.5152 17.6713 20.4998H1.92131V18.8331H17.6713C17.8975 18.8483 18.1206 18.7737 18.2922 18.6255C18.4638 18.4773 18.5701 18.2675 18.588 18.0414V8.79145C18.5701 8.56543 18.4638 8.35558 18.2922 8.20739C18.1206 8.05919 17.8975 7.9846 17.6713 7.99978H2.58214L6.16547 11.5831L4.98964 12.7648Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4578_253969"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "matrix(-1 0 0 1 20.2546 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndo);
export default __webpack_public_path__ + "static/media/undo.7190d97669c007ddc1001a025d547d0f.svg";
export { ForwardRef as ReactComponent };